export function pathOrg(pathParams: { orgId: string } = { orgId: ':orgId' }) {
  return `/org/${pathParams.orgId ?? ':orgId'}`;
}
export function pathManagementScheduling(pathParams?: { orgId: string }) {
  return `${pathManagement(pathParams)}/scheduling`;
}
export function pathManagementSchedulingCrew(pathParams?: { orgId: string }) {
  return `${pathManagement(pathParams)}/scheduling/crew`;
}
export function pathManagement(pathParams?: { orgId: string }) {
  return `${pathOrg(pathParams)}/management`;
}
export function pathSiteMonitoringPerformancePublicTransportSegment(pathParams?: {
  orgId: string;
  siteId: string;
}) {
  return `${pathSiteMonitoringPerformance(pathParams)}/public-transport/segment`;
}

export function pathManagementProject(pathParams?: {
  orgId: string;
  projectId: string;
}) {
  return `${pathManagement(pathParams)}/project/${pathParams?.projectId ?? ':projectId'}`;
}
export function pathOperationsHub(pathParams?: { orgId: string }) {
  return `${pathOrg(pathParams)}/operations-hub`;
}
export function pathOperationsHubRoute(pathParams?: {
  orgId: string;
  routeId: string;
}) {
  return `${pathOperationsHub(pathParams)}/route/${pathParams?.routeId ?? ':routeId'}`;
}

export function pathReporting(pathParams?: { orgId: string }) {
  return `${pathOrg(pathParams)}/reporting`;
}

export function pathOrgUserAccount(pathParams?: { orgId: string }) {
  return `${pathOrg(pathParams)}/user-account`;
}

export function pathOrgUserPreference(pathParams?: { orgId: string }) {
  return `${pathOrgUserAccount(pathParams)}/preference`;
}

export function pathOrgSettings(pathParams?: { orgId: string }) {
  return `${pathOrg(pathParams)}/settings`;
}
export function pathOrgTeamSettings(pathParams?: { orgId: string }) {
  return `${pathOrgSettings(pathParams)}/team`;
}
export function pathOrgContractorsSettings(pathParams?: {
  orgId: string;
  contractorId: string | null;
}) {
  if (!pathParams) {
    return `${pathOrgSettings()}/contractors/:contractorId?`;
  }
  return `${pathOrgSettings(pathParams)}/contractors${pathParams.contractorId ? `/${pathParams.contractorId}` : ''}`;
}
export function pathOrgSettingsAccount(pathParams?: { orgId: string }) {
  return `${pathOrgSettings(pathParams)}/account`;
}
export function pathOrgTeamFragmentSettings(pathParams?: {
  orgId: string;
  fragment: string;
}) {
  return `${pathOrgTeamSettings(pathParams)}/${pathParams?.fragment ?? ':sectionId'}`;
}

// TODO [FEATURE_PROFILE_EDITING]: Remove this path on feature cleanup
export function pathOrgUserSettings(pathParams?: { orgId: string }) {
  return `${pathOrgSettings(pathParams)}/profile`;
}
export function pathOrgDataSourcesSettings(pathParams?: { orgId: string }) {
  return `${pathOrgSettings(pathParams)}/data-sources`;
}

export function pathSiteMonitoringIndex(pathParams?: { orgId: string }) {
  return `${pathOrg(pathParams)}/site`;
}

export function pathSiteMonitoring(pathParams?: {
  orgId: string;
  siteId: string;
}) {
  return `${pathOrg(pathParams)}/site/${pathParams?.siteId ?? ':siteId'}`;
}
export function pathSiteMonitoringPlanning(pathParams?: {
  orgId: string;
  siteId: string;
}) {
  return `${pathSiteMonitoring(pathParams)}/planning`;
}
export function pathSiteMonitoringPerformance(pathParams?: {
  orgId: string;
  siteId: string;
}) {
  return `${pathSiteMonitoring(pathParams)}/performance`;
}
export function pathSiteMonitoringPerformancePublicTransport(pathParams?: {
  orgId: string;
  siteId: string;
}) {
  return `${pathSiteMonitoringPerformance(pathParams)}/public-transport`;
}

export function pathSiteMonitoringEdit(pathParams?: {
  orgId: string;
  siteId: string;
}) {
  return `${pathSiteMonitoring(pathParams)}/edit`;
}

export function pathSiteMonitoringAlerts(pathParams?: {
  orgId: string;
  siteId: string;
}) {
  return `${pathSiteMonitoring(pathParams)}/alerts`;
}

export function pathSiteMonitoringVms(pathParams?: {
  orgId: string;
  siteId: string;
}) {
  return `${pathSiteMonitoring(pathParams)}/vms`;
}

export function pathSiteMonitoringVmsBoard(pathParams?: {
  orgId: string;
  siteId: string;
  vmsConfigId?: string;
}) {
  return `${pathSiteMonitoringVms(pathParams)}/board/${!pathParams ? ':vmsConfigId?' : (pathParams.vmsConfigId ?? '')}`;
}
